/* eslint-disable jsx-a11y/anchor-is-valid */
import moment from 'moment'
import {SnackbarProvider} from 'notistack'
import {FC, useState} from 'react'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {KTableLoading} from '../../../../../../components/UI'
import {KTableProvider} from '../../../../../../contexts/KTableProvider'
import {getSnackBar, getSnackBarToast} from '../../../../../../util/snackBar'
import {RatioOccupancyBedStatusData} from '../../../../models/reports.model'
import {
  getRatioOccupancyByBedStatusCSVService,
  getRatioOccupancyByBedStatusPDFService,
  getRatioSalesDeOccupancyByBedStatusExcelService,
} from '../../../../services/ratio.service'

interface Props {
  datos: RatioOccupancyBedStatusData[]
  loading: boolean
  formValue: any
}

const TableReportRadioOccupancyBedStatusRoom: FC<Props> = ({datos, loading, formValue}) => {
  const [isDownloadXLS, setIsDownloadXLS] = useState<boolean>(false)
  const [isDownloadCSV, setIsDownloadCSV] = useState<boolean>(false)
  const [isDownloadPDF, setIsDownloadPDF] = useState<boolean>(false)

  const handleExportXLS = async () => {
    try {
      setIsDownloadXLS(true)
      const response = await getRatioSalesDeOccupancyByBedStatusExcelService(formValue)
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      // Crea un enlace temporal y simula un clic para descargar el archivo
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `Ratios Ocupabilidad Estado de Cama-${moment()
        .format('DD/MM/YY HH:mm')
        .toString()}.xlsx` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      setIsDownloadXLS(false)
      getSnackBarToast('Se descargó el documento con éxito', 'success')
    } catch (error) {
      setIsDownloadXLS(false)
      getSnackBarToast('Hubo un error al descargar', 'error')
    }
  }
  const handleExportCSV = async () => {
    try {
      setIsDownloadCSV(true)
      const response = await getRatioOccupancyByBedStatusCSVService(formValue)
      const blob = new Blob([response.data], {
        type: 'application/pdf',
      })
      // Crea un enlace temporal y simula un clic para descargar el archivo
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `Ratios Ratios Ocupabilidad Estado de Cama-${moment()
        .format('DD/MM/YY HH:mm')
        .toString()}.csv` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      getSnackBarToast('Se descargó el documento con éxito', 'success')
      setIsDownloadCSV(false)
    } catch (error) {
      setIsDownloadCSV(false)
      getSnackBarToast('Hubo un error al descargar', 'error')
      //
    }
  }
  const handleExportPDF = async () => {
    try {
      setIsDownloadPDF(true)
      const response = await getRatioOccupancyByBedStatusPDFService(formValue)
      const blob = new Blob([response.data], {
        type: 'text/csv',
      })
      // Crea un enlace temporal y simula un clic para descargar el archivo
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `Ratios Ratios Ocupabilidad Estado de Cama-${moment()
        .format('DD/MM/YY HH:mm')
        .toString()}.pdf` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      setIsDownloadPDF(false)
      getSnackBarToast('Se descargó el documento con éxito', 'success')
    } catch (error) {
      setIsDownloadPDF(false)
      getSnackBarToast('Hubo un error al descargar', 'error')
    }
  }

  return (
    <>
      <KTCard shadow className='m-5'>
        <div className='d-flex justify-content-end p-2 me-5'>
          <button
            type='button'
            className='btn btn-success me-3'
            disabled={datos.length < 1 || isDownloadXLS}
            onClick={handleExportXLS}
          >
            {isDownloadXLS && (
              <div className='icon-container'>
                <i className='loader'></i>
              </div>
            )}
            Descargar Excel
          </button>
          <button
            type='button'
            className='btn btn-success me-3'
            disabled={datos.length < 1 || isDownloadCSV}
            onClick={handleExportCSV}
          >
            {isDownloadCSV && (
              <div className='icon-container'>
                <i className='loader'></i>
              </div>
            )}
            Descargar CSV
          </button>
          <button
            type='button'
            className='btn btn-success me-3'
            disabled={datos.length < 1 || isDownloadPDF}
            onClick={handleExportPDF}
          >
            {isDownloadPDF && (
              <div className='icon-container'>
                <i className='loader'></i>
              </div>
            )}
            Descargar PDF
          </button>
        </div>
        {loading ? <KTableLoading title='Cargando...' /> : null}
        <div className='card-body'>
          <div className='table-responsive'>
            <table className='table gs-7 gy-7 gx-7 table-row-bordered table-hover'>
              <thead>
                <tr className='border-top border-gray-200'>
                  <th
                    rowSpan={2}
                    className={
                      'fw-bold fs-6 text-center text-gray-800 border-bottom border-gray-200'
                    }
                    style={{
                      minWidth: '200px',
                      borderRight: '1px solid black',
                      borderLeft: '1px solid black',
                    }}
                  >
                    ESTADO
                  </th>
                  <th
                    colSpan={2}
                    className={
                      'fw-bold fs-6 text-center text-gray-800 border-bottom border-gray-200'
                    }
                    style={{borderRight: '1px solid black'}}
                  >
                    CAPACIDAD ALOJAMIENTO
                  </th>
                  <th
                    colSpan={2}
                    className={
                      'fw-bold fs-6 text-center text-gray-800 border-bottom border-gray-200'
                    }
                    style={{borderRight: '1px solid black'}}
                  >
                    OCUPADAS
                  </th>
                  <th
                    colSpan={2}
                    className={
                      'fw-bold fs-6 text-center text-gray-800 border-bottom border-gray-200'
                    }
                    style={{borderRight: '1px solid black'}}
                  >
                    RESERVADO
                  </th>
                  <th
                    colSpan={2}
                    className={
                      'fw-bold fs-6 text-center text-gray-800 border-bottom border-gray-200'
                    }
                    style={{borderRight: '1px solid black'}}
                  >
                    BLOQUEADO
                  </th>
                  <th
                    colSpan={2}
                    className={
                      'fw-bold fs-6 text-center text-gray-800 border-bottom border-gray-200'
                    }
                    style={{borderRight: '1px solid black'}}
                  >
                    DISPONIBLE
                  </th>
                  <th
                    colSpan={2}
                    className={
                      'fw-bold fs-6 text-center text-gray-800 border-bottom border-gray-200'
                    }
                    style={{borderRight: '1px solid black'}}
                  >
                    % OCUPACION
                  </th>
                  <th
                    colSpan={2}
                    className={
                      'fw-bold fs-6 text-center text-gray-800 border-bottom border-gray-200'
                    }
                    style={{borderRight: '1px solid black'}}
                  >
                    % DISPONIBILIDAD
                  </th>
                </tr>
                <tr className='fw-bold fs-6 text-gray-800 border-bottom border-gray-200'>
                  <th
                    className={'border-gray-200'}
                    style={{minWidth: '170px', borderRight: '1px solid black'}}
                  >
                    Camas (C.I + C.C)
                  </th>
                  <th className={'border-gray-200'} style={{borderRight: '1px solid black'}}>
                    Habitaciones
                  </th>
                  <th
                    className={'border-gray-200'}
                    style={{minWidth: '170px', borderRight: '1px solid black'}}
                  >
                    Camas (C.I + C.C)
                  </th>
                  <th className={'border-gray-200'} style={{borderRight: '1px solid black'}}>
                    Habitaciones
                  </th>
                  <th
                    className={'border-gray-200'}
                    style={{minWidth: '170px', borderRight: '1px solid black'}}
                  >
                    Camas (C.I + C.C)
                  </th>
                  <th className={'border-gray-200'} style={{borderRight: '1px solid black'}}>
                    Habitaciones
                  </th>
                  <th className={'border-gray-200'} style={{borderRight: '1px solid black'}}>
                    Camas
                  </th>
                  <th className={'border-gray-200'} style={{borderRight: '1px solid black'}}>
                    Habitaciones
                  </th>
                  <th
                    className={'border-gray-200'}
                    style={{minWidth: '170px', borderRight: '1px solid black'}}
                  >
                    Camas (C.I + C.C)
                  </th>
                  <th className={'border-gray-200'} style={{borderRight: '1px solid black'}}>
                    Habitaciones
                  </th>
                  <th className={'border-gray-200'} style={{borderRight: '1px solid black'}}>
                    Camas
                  </th>
                  <th className={'border-gray-200'} style={{borderRight: '1px solid black'}}>
                    Habitaciones
                  </th>
                  <th className={'border-gray-200'} style={{borderRight: '1px solid black'}}>
                    Camas
                  </th>
                  <th className={'border-gray-200'} style={{borderRight: '1px solid black'}}>
                    Habitaciones
                  </th>
                </tr>
              </thead>
              <tbody>
                {datos.map((item, idx) => (
                  <tr key={idx}>
                    <td className='border border-gray-200'>{item.TipoNombre}</td>
                    <td className='border border-gray-200'>{item.CapTotalCamas}</td>
                    <td className='border border-gray-200'>{item.CapTotalHabitaciones}</td>
                    <td className='border border-gray-200'>{item.OcupCamas}</td>
                    <td className='border border-gray-200'>{item.OcupHabitaciones}</td>
                    <td className='border border-gray-200'>{item.ReservaCamas}</td>
                    <td className='border border-gray-200'>{item.ReservaHabitaciones}</td>
                    <td className='border border-gray-200'>{item.BloqCamas}</td>
                    <td className='border border-gray-200'>{item.BloqHabitaciones}</td>
                    <td className='border border-gray-200'>{item.DispoCamas}</td>
                    <td className='border border-gray-200'>{item.DispoHabitaciones}</td>
                    <td className='border border-gray-200'>{item.PorcOcupCamas}</td>
                    <td className='border border-gray-200'>{item.PorcOcupHabitaciones}</td>
                    <td className='border border-gray-200'>{item.PorcDispoCamas}</td>
                    <td className='border border-gray-200'>{item.PorcDispoHabitaciones}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </KTCard>
    </>
  )
}

const TableReportRatioOccupancyByBedStatusWrapper: FC<Props> = ({datos, loading, formValue}) => {
  return (
    <KTableProvider>
      <TableReportRadioOccupancyBedStatusRoom
        datos={datos}
        loading={loading}
        formValue={formValue}
      />
      <SnackbarProvider />
    </KTableProvider>
  )
}

export {TableReportRatioOccupancyByBedStatusWrapper}
